define(function(require) {

const tpl = require('civicsViews/search_view/templates/t_itv_empty_record_list.hbs');

	return Marionette.ItemView.extend({
    tagName: 'li',
    className: 'list-item-row empty',
    template: tpl,
    initialize: function(options) {
      this.emptyMessage = options.emptyMessage;
    },
    templateHelpers: function () {
      var self = this;
      return {
        emptyMessage: self.emptyMessage
      };
    },
	});
});
